module.exports = __webpack_public_path__ + "img/header.b6763b4d.webp";